import headroom from 'headroom.js';

window.Headroom = headroom;
